import React, { useState, useEffect } from "react";
import ToastContainer from "./ToastContainer.tsx";
import messageService from "./message.ts";

interface MessageProviderProps {
  children: React.ReactNode;
}

const MessageProvider: React.FC<MessageProviderProps> = ({ children }) => {
  const [toasts, setToasts] = useState<any[]>([]);

  useEffect(() => {
    const unsubscribe = messageService.subscribe(setToasts);
    return unsubscribe;
  }, []);

  const handleClose = (id: string) => {
    messageService.remove(id);
  };

  return (
    <>
      {children}
      <ToastContainer toasts={toasts} onClose={handleClose} />
    </>
  );
};

export default MessageProvider;
